import screenFull from 'screenfull';

/**
 * 指定元素节点中的内容全屏显示，依赖screenfull插件
 * @param id 元素节点ID
 */
export function elementFullScreen(id) {
  if (id) {
    // 指定全屏区域元素
    const element = document.getElementById(id);
    if (screenFull.isEnabled) {
      if (screenFull.isFullscreen) {
        screenFull.exit();
      } else {
        screenFull.request(element);
      }
    } else {
      console.warn('您的浏览器不支持全屏');
    }
  }
}


/**
 * 处理监听自定义元素大小变化（宽度和调试）事件
 * @param id 元素ID
 * @param callback 回调
 */
export function handleCustomElementResize(id, callback) {
  const elementResizeDetectorMaker = require('element-resize-detector');
  const erd = elementResizeDetectorMaker();
  erd.listenTo(document.getElementById(id), callback);
}


/**
 * 处理监听自定义元素大小变化（宽度和调试）事件
 * @param elementNode dom节点
 * @param callback 回调
 */
export function handleCustomNodeResize(elementNode, callback) {
  if (elementNode) {
    const elementResizeDetectorMaker = require('element-resize-detector');
    const erd = elementResizeDetectorMaker();
    erd.listenTo(elementNode, callback);
  }
}
